import { BillRepository } from "../../repositories/BillRepository";
import { BillOperationResult, BillDataEntity } from "../../entities/BillEntity";

/**
 * Process Bill JSON Use Case
 * Processes bill JSON for GL classification
 */
export class ProcessBillJsonUseCase {
  constructor(private repository: BillRepository) {}

  async execute(billData: BillDataEntity): Promise<BillOperationResult> {
    // Validate bill data
    // if (!billData) {
    //   throw new Error("Bill data is required");
    // }

    // if (!billData.line_items || billData.line_items.length === 0) {
    //   throw new Error("Bill must have at least one line item");
    // }

    // // Validate each line item has required GL information
    // const invalidItems = billData.line_items.filter(
    //   (item) => !item.account_id || !item.account_name
    // );

    // if (invalidItems.length > 0) {
    //   throw new Error(
    //     "All line items must have account_id and account_name for GL classification"
    //   );
    // }

    return await this.repository.processBillJson(billData);
  }
}
